import { render, staticRenderFns } from "./IconApprovalDoc.vue?vue&type=template&id=4886adca&"
import script from "./IconApprovalDoc.vue?vue&type=script&lang=js&"
export * from "./IconApprovalDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports